
import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { amountFormatUse, getToken, utc_local } from '../../../helpers/Helper';
import { post } from '../../../helpers/api_helper';
import { POST_GET_USER_DETAIL, POST_USER_SUBSCRIPTION_LIST, POST_USER_INVOICES_LIST, POST_PDF_INVOICE, POST_GET_GENERATE_INVOICE } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";
import Loader from '../../../components/Loader';

import SimpleReactValidator from 'simple-react-validator';


const UserRoles = (props) => {
    const navigate = useNavigate();
    const { id } = useParams()
    const [isLoader, setLoader] = useState(true);
    
    
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [subscriptionPlan, SetSubscriptionPlan] = useState([]);
    const [userInfo, SetUserInfo] = useState({});
    const [invoiceInfo, SetinvoiceInfo] = useState({userId : '', planId : '', subscriptionType : '', totalAmount : 0,  paymentId : '', paymentMethod : 'UPI'});

    const simpleValidator = useRef(new SimpleReactValidator());
    const [, forceUpdate] = useState();



    useMounted(() => {
        getUserDetail()
    })

    const getUserDetail = async () => {
        setLoader(true);
        var res_data = await post(POST_GET_USER_DETAIL, { 'userId': id });
        if (res_data.status) {
            SetUserInfo(res_data.data.user_detail);
            SetSubscriptionPlan(res_data.data.subscription_plan);
            setLoader(false);

            setTimeout(() => {
                getSubscription()
                getInvoiceList()
            }, 500);
        } else {
            setLoader(false);
            toast.error(res_data.message);
            navigate("/admin/dashboard");
        }
    }

    const getSubscription = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [5] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';
                    data.userId = id

                    $.ajax({
                        "url": POST_USER_SUBSCRIPTION_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "subscriptionId" },
                    { "data": "name" },
                    { "data": "chequePrint" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.startDate)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.endDate)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button className={`border-0 badge ${(data.status === 'Active') ? 'bg-success' : 'bg-danger'}`}>{data.status}</button>
                            </>)
                        }
                    },
                ]
            });
        }
    }

    const getInvoiceList = () => {
        const tableElement = $('#dataTableExampleInvoice');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [5,6] },
                    { "targets": '', "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';
                    data.userId = id;

                    $.ajax({
                        "url": POST_USER_INVOICES_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "invoiceId" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.createdAt)}
                            </>)
                        }
                    },
                    { "data": "userName" },
                    { "data": "name" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                ₹{data.totalAmount}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {data.paymentStatus === 'Unpaid' && <span className='text-danger'>{data.paymentStatus}</span>}
                                {data.paymentStatus === 'Paid' && <span className='text-success'>{data.paymentStatus}</span>}
                                {data.paymentStatus === 'Canceled' && <span className='text-danger'>{data.paymentStatus}</span>}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <a href={`${POST_PDF_INVOICE}${data.invoiceId}`} target="_blank" rel="noreferrer" className={`btn btn-sm text-info`}><i className="bx bxs-file-pdf"></i></a>
                                {/* {data.paymentStatus === 'Unpaid' && 
                                    <button  onClick={() => { navigate('/invoices/pay/' + data.invoiceId); }} className='btn btn-sm btn-success'>Pay</button>
                                } */}
                            </>)
                        }
                    },

                ]
            });
        }
    }

    const handleInputChange = (event) => {
        event.persist();
        if (event.target.name === 'planId') {
            invoiceInfo.totalAmount = 0;
            for(const planof of subscriptionPlan){
                if(planof.planId == event.target.value){
                    invoiceInfo.totalAmount = planof.price;
                    break;
                }
            }
            invoiceInfo[event.target.name] = event.target.value;
        }else{
            invoiceInfo[event.target.name] = event.target.value;
        }
        SetinvoiceInfo({...invoiceInfo});
    }

    const setinvoice_info = () => {
        SetinvoiceInfo({userId : id, planId : '', subscriptionType : '', totalAmount : 0,  paymentId : '', paymentMethod : 'UPI'})
    }

    const generateInvoice = async () => {
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_GET_GENERATE_INVOICE, invoiceInfo);
            if (res_data.status) {
                getSubscription();
                getInvoiceList();
                window.$('#InvoiceModal').modal('hide');
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);

        }
    }

    
    return (
        <>
            {isLoader && <Loader />}
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>User Detail</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                    {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>}
                                    <a href={`/?id=${userInfo.userId}`} className='btn btn-sm' rel="noreferrer" target="_blank"><i className="bx bx-log-in align-middle text-primary"></i></a>
                                </div>
                            </div>
                            <hr />
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <b>Company Name </b><br />
                                    <p>{userInfo.companyName} </p>
                                </div>
                                <div className='col-sm-4'>
                                    <b>User Name </b><br />
                                    <p>{userInfo.name}</p>
                                </div>
                                <div className='col-sm-4'>
                                    <b>Mobile Nummber </b><br />
                                    <p>{userInfo.mobileNo}</p>
                                </div>
                                <div className='col-sm-4'>
                                    <b>User Email </b><br />
                                    <p>{userInfo.email}</p>
                                </div>
                                <div className='col-sm-4'>
                                    <b>Country Name</b><br />
                                    <p>{userInfo.countryName}</p>
                                </div>
                                {userInfo.userIpAddress && 
                                    <div className='col-sm-4'>
                                        <b>Ip Address</b><br />
                                        <a href={`https://check-host.net/ip-info?host=${userInfo.userIpAddress}`} className='text-primary' target="_blank" rel="noopener noreferrer">{userInfo.userIpAddress}</a>
                                    </div>
                                }
                            </div>

                            <hr />
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <h5 className='mt-1'>Subscriptions</h5>
                                </div>
                                <div className='col-sm-12'>
                                    <div className='table-responsive text-nowrap'>
                                        <table id="dataTableExample" className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <td>Id</td>
                                                    <td>Name</td>
                                                    <td>Credit</td>
                                                    <td>StartDate</td>
                                                    <td>End Date</td>
                                                    <td>Status</td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <hr />
                            <div className='row'>
                                <div className='col-6'>
                                    <h5 className='mt-1'>Invoices</h5>
                                </div>
                                <div className='col-6 text-right'>
                                    <button type='button' onClick={setinvoice_info} className="btn btn-sm btn-primary mr-2" data-bs-toggle="modal" data-bs-target="#InvoiceModal">Generate Invoice</button>
                                </div>
                                <div className='col-sm-12'>
                                    <div className='table-responsive text-nowrap'>
                                        <table id="dataTableExampleInvoice" className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <td>Invoice</td>
                                                    <td>Invoice Date</td>
                                                    <td>User Name</td>
                                                    <td>Plan Name</td>
                                                    <td>Total</td>
                                                    <td>Status</td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="InvoiceModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Invoice</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-sm-6'>
                                    <p className='mb-0'><b>Company Name</b></p>
                                    <p className='mb-2'>{userInfo.companyName}</p>
                                    <p className='mb-0'><b>User Email</b></p>
                                    <p className='mb-2'>{userInfo.email}</p>
                                </div>
                                <div className='col-sm-6'>
                                    <p className='mb-0'><b>User Name</b></p>
                                    <p className='mb-2'>{userInfo.name}</p>
                                    <p className='mb-0'><b>Mobile Number</b></p>
                                    <p className='mb-2'>{userInfo.mobileNo}</p>
                                </div>
                            </div>
                            <div className='row mt-4'>
                                <div className='col-sm-12'>
                                    <div className='table-responsive table-small'>
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th>Plan</th>
                                                    <th>Type</th>
                                                    <th width="150px" className='text-center'>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <select className='form-control' name='planId' onChange={handleInputChange} value={invoiceInfo.planId}>
                                                            <option value="">Select Plan</option>
                                                            {subscriptionPlan.map((value) => {
                                                                return <option value={value.planId} key={value.planId}>{value.name}</option>;
                                                            })}
                                                        </select>
                                                        {simpleValidator.current.message('plan', invoiceInfo.planId, 'required')}
                                                    </td>
                                                    <td>
                                                        <select className='form-control' name='subscriptionType' onChange={handleInputChange} value={invoiceInfo.subscriptionType}>
                                                            <option value="">Subscription Type</option>
                                                            <option value="monthly">Monthly</option>
                                                            <option value="annually">Annually</option>
                                                        </select>
                                                        {simpleValidator.current.message('type', invoiceInfo.subscriptionType, 'required')}
                                                    </td>
                                                    <td>
                                                    {amountFormatUse(invoiceInfo.totalAmount)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <input type='text' className='form-control' name='paymentId' onChange={handleInputChange} value={invoiceInfo.paymentId} placeholder='Transaction Id' />
                                                        {/* {simpleValidator.current.message('transaction id', invoiceInfo.paymentId, 'required')} */}
                                                    </td>
                                                    <td className='text-right'>Grand Total </td>
                                                    <td>
                                                        {amountFormatUse(invoiceInfo.totalAmount)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className='row mt-4'>
                                <div className='col-sm-12 text-center'>
                                    <button type="button" disabled={ButtonDisabled} className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button> &nbsp; &nbsp; &nbsp; &nbsp;
                                    <button onClick={generateInvoice} disabled={ButtonDisabled} className="btn btn-primary"> {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Generate Invoice</button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

      
        </>
    );
}

export default UserRoles;